import { usePlanningFormTranslation } from '@libs/utils/translations'
import styles from '@spa/scenes/Plannings/Forms/RealHoursForms/components/MealCol/MealCol.module.css'
import type { FC } from 'react'

const MealNotTaken: FC = () => {
  const { t } = usePlanningFormTranslation()

  return (
    <span className={styles.NotTaken}>
      {t('shiftRealHoursForm.mealCol.untaken')}
    </span>
  )
}

export default MealNotTaken
